import { UiStage } from '@xbcb/ui-types';
import { isProject42Enabled } from '../../../featureFlags';
import { ClassificationService } from './classificationService';
import { MockClassificationService } from './mockClassificationService';

/**
 * Get the right classification service based on the UI context.
 * @param {UiStage} stage The UI stage currently running.
 * @param {string} shipper The shipper account ID of the current session.
 * @return {ClassificationService} The appropriate classification service.
 */
export const getClassificationService = (
  stage: UiStage,
  shipper: string,
): ClassificationService => {
  if (
    isProject42Enabled({
      stage,
      shipperId: shipper,
    })
  ) {
    return new MockClassificationService();
  } else {
    throw new Error(
      `Could not determine appropriate classification service for stage: ${stage} and shipper: ${shipper}`,
    );
  }
};
